import rotatePolygon from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/rotatePolygon';
import getSquareCenter from './getSquareCenter';

function getPolygonPoints(square) {
    const {
        compiled: {
            polygon: {
                dimensions: { width, height },
            },
        },
    } = square;

    const center = getSquareCenter(square);

    let points = [
        { x: center.x - width / 2, y: center.y - height / 2 },
        { x: center.x + width / 2, y: center.y - height / 2 },
        { x: center.x + width / 2, y: center.y + height / 2 },
        { x: center.x - width / 2, y: center.y + height / 2 },
    ];

    if (square.transformation.rotation !== 0) {
        points = rotatePolygon(points, center, square.transformation.rotation);
    }

    return points;
}

export default getPolygonPoints;
